import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { setHoursWork } from "../../../Store/Slice/scheduleSlice";

const useGetTimesInDay = () => {
  const dispatch = useDispatch();
  const allDays = useSelector(
    (state) => state.rootReducer.scheduleSlice.allDays
  );
  const get = (day) => {
    let hours = null;
    allDays?.forEach((item, index) => {
      for (let key in item) {
        if (item[key]?.day == moment(day).format("D")) {
          hours = item[key].hours;
        }
      }
    });
    dispatch(setHoursWork(hours));
  };

  return {
    get,
  };
};

export default useGetTimesInDay;
